export default __webpack_public_path__ + "static/media/bg-AWB.4635e493.png";